module.exports = __webpack_public_path__ + "img/imgfftBR3.47daa261.png";